<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M2 5h20v2H2V5zm0 12h15v2H2v-2zm0-6h20v2H2v-2z"/></svg>